import styled from 'styled-components';

interface IContainer {
  isActived: boolean;
  isDisabled?: boolean;
}

export const Container = styled.div`
  .label {
    margin-top: -26px;
    margin-left: -13px;
    position: absolute;
    font-size: 0.8571428571428571em;
    line-height: 1.3;
    color: #6b778c;
    font-weight: 600;
    font-style: inherit;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
  }
`;

export const RadioColor = styled.div<IContainer>`
  background: ${(props) => (props.isActived ? '#57069e' : '#8850bf')};
  border-radius: 5px;
  height: 30px;
  min-width: 70px;
  display: flex;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  position: relative;
  transition: all 0.2s ease-in-out;
  opacity: ${(props) => (props.isDisabled ? 0.6 : 1)};
  &:hover {
    transform: ${(props) => (props.isDisabled ? 'none' : 'translateY(-1px)')};
  }

  &:active {
    transform: translateY(0);
    transition: all 0.1s ease-in-out;
  }

  label {
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    color: #fff !important;
    opacity: ${(props) => (props.isDisabled ? 0.6 : 1)};
  }

  input[type='radio'] {
    position: relative;
    margin-right: 5px;
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    width: 13px;
    height: 13px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #fff;
    outline: none;

    &:focus {
      border-color: #fff !important;
      box-shadow: none !important;
    }

    &:checked {
      background: #8850bf;
      border: 2px solid transparent;
      position: relative;
    }

    &:checked::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: #fafbfc;
    }
    &:disabled {
      cursor: not-allowed;

      &:focus,
      &:focus-within,
      &:focus-visible {
        outline: none;
        box-shadow: none;
      }
    }
  }

  span {
    color: #fff !important;
    font-family: 'Jost', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    letter-spacing: 0.025em !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    white-space: nowrap;
  }

  & + & {
    margin-left: 8px;
  }
`;
